import { call, fork, put, take } from "redux-saga/effects";

import { Project } from "../../domain/model/project";
import { Customer } from "../../domain/model/customer";
import { Contract } from "../../domain/model/contract";
import { IProjectRepository } from "../../domain/repository/project_repository";
import { ICustomerRepository } from "../../domain/repository/customer_repository";
import { IContractRepository } from "../../domain/repository/contract_repository";

import { createProjectAPI } from "../../infra/api/service/project_api";
import { createCustomerAPI } from "../../infra/api/service/customer_api";
import { createContractAPI } from "../../infra/api/service/contract_api";
import { createApiClient, IApiClient } from "../../infra/api/client";

import {
  IClientContractListActionCreator,
  ClientContractListActionType,
  createClientContractListActionCreator,
  IRequestGetAllContractListByClientAction,
} from "../action/client_contracts_action";

const apiClient: IApiClient = createApiClient();
const projectRepository: IProjectRepository = createProjectAPI(apiClient);
const customerRepository: ICustomerRepository = createCustomerAPI(apiClient);
const contractRepository: IContractRepository = createContractAPI(apiClient);
const actionCreator: IClientContractListActionCreator =
  createClientContractListActionCreator();

import { GetAllContractListByClientResponse } from "../response/contract_response";
import { handleErrorForHandler } from "./handleErrorForHandler";

function* handleGetAllByClientInClientContractList() {
  while (true) {
    try {
      const action: IRequestGetAllContractListByClientAction = yield take(
        ClientContractListActionType.REQUEST_GET_ALL_CONTRACT_LIST_BY_CLIENT
      );
      const contructList: Contract[] = yield call(
        getAllByClient,
        action.item.pager.page,
        action.item.pager.offset
      );
      const contructCount: number = yield call(getCountByClient);
      const projectIdList: string[] = yield call(
        createProjectIdList,
        contructList
      );
      const projectList: Project[] = yield call(getProjectList, projectIdList);
      const customerIdList: string[] = yield call(
        createCustomerIdList,
        contructList
      );
      const customerList: Customer[] = yield call(
        getCustomerList,
        customerIdList
      );
      const res: GetAllContractListByClientResponse =
        new GetAllContractListByClientResponse();
      res.contractList = contructList;
      res.contractCount = contructCount;
      res.projectList = projectList;
      res.customerList = customerList;
      yield put(actionCreator.callbackGetAllByClientContractAction(true, res));
    } catch (error) {
      yield fork(handleErrorForHandler, error);
      yield put(
        actionCreator.callbackGetAllByClientContractAction(
          false,
          undefined,
          error.toString()
        )
      );
    }
  }
}

const createProjectIdList = (contractList: Contract[]): string[] => {
  return contractList.map((item) => {
    return item.projectID;
  });
};

const createCustomerIdList = (contractList: Contract[]): string[] => {
  return contractList.map((item) => {
    return item.customerID;
  });
};

const getProjectList = (projectIdList: string[]): Promise<Project[]> => {
  return projectRepository.getAllByIDs(projectIdList);
};

const getCustomerList = (customerIdList: string[]): Promise<Customer[]> => {
  return customerRepository.getAllByIDs(customerIdList);
};

const getAllByClient = (page: number, offset: number): Promise<Contract[]> => {
  return contractRepository.getAll(page, offset);
};

const getCountByClient = (): Promise<number | Long> => {
  return contractRepository.getCount();
};

export { handleGetAllByClientInClientContractList };



// WEBPACK FOOTER //
// ./src/presentation/handler/client_contracts_handler.ts